import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import Professional from './components/Professional';
import Personal from './components/Personal';
import TimeOff from './components/TimeOff';
import Pto from './components/Pto'
import PtoRequest from './components/PtoRequest'
import PtoBalance from './components/PtoBalance'
import PtoManager from './components/PtoManager'
import PtoCompressed from './components/PtoCompressed'
import PersonalStudent from './components/PersonalStudent'
import ParentGuardian from './components/ParentGuardian'
import VueCountryCode from 'vue-country-code'
import OfficeHourManager from "./components/OfficeHourManager";
import DepartmentSchedules from "./components/DepartmentSchedules.vue";
import { checkHoursManagerUser } from "./assets/staticState";
Vue.use(VueCountryCode);

Vue.config.productionTip = false;

Vue.use(VueRouter);

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("MMMM D, YYYY");
  }
});

const routes = [
  { path: "", component: Professional },
  { path: "/professional", component: Professional },
  { path: "/personal", component: Personal },
  { path: "/time-off", component: TimeOff },
  {
    path: "/pto",
    component: Pto,
    children: [
      { path: "", component: PtoRequest },
      { path: "request", component: PtoRequest },
      { path: "balancePrev", component: PtoBalance },
      { path: "balance", component: PtoBalance },
      { path: "balanceNext", component: PtoBalance },
      { path: "manager", component: PtoManager },
      { path: "compressed", component: PtoCompressed },
    ],
  },
  {
    path: "/Benefits",
    beforeEnter() {
      location.href = "https://class.adelphi.edu/benefits/";
    },
  },
  {
    path: "/Totals",
    beforeEnter() {
      location.href = "https://class.adelphi.edu/benefits-report/";
    },
  },
  { path: '/personal-student', component: PersonalStudent },
  { path: '/parent-guardian', component: ParentGuardian },
  {
    path: "/office_hour_manager",
    component: OfficeHourManager,
    meta: { requiresAuth: true },
  },
  {
    path: "/office_hour_manager/:id",
    component: DepartmentSchedules,
    meta: { requiresAuth: true },
    props: (route) => ({
      department: JSON.parse(decodeURIComponent(route.query.department)),
    }),
  }
];

// mode: 'history',
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const admin = JSON.parse(sessionStorage.getItem("isAdmin"));
    const allDepartmentAccess=JSON.parse(sessionStorage.getItem("allDepartmentAccess"));
    const userDepartmentList = JSON.parse(
      sessionStorage.getItem("userDepartments")
    );
    if (admin || allDepartmentAccess||userDepartmentList!==null) {
      next();
    }
    next(false);
  } else {
    next(); // Always call next() to resolve routes other than requireauth
  }
});
// router.afterEach((to) => {
//   // Dynamically set the document title based on the route's meta.title
//   if (to.meta && to.meta.title) {
//     document.title = to.meta.title;
//   } else {
//     document.title = "My Profile"; 
//   }
// });

router.afterEach((to) => {
  // Check if the path is '/office_hour_manager' or '/office_hour_manager/:id'
  if (to.path.startsWith('/office_hour_manager')) {
    document.title = "Office Hour Manager"; // Set the document title
  } 
});

checkHoursManagerUser()
  .then(() => {
    new Vue({
      vuetify,
      router,
      VueTheMask,
      render: (h) => h(App),
    
    }).$mount("#app");
  })
  .catch(() => {
    new Vue({
      vuetify,
      router,
      VueTheMask,
      render: (h) => h(App),
    
    }).$mount("#app");
  });
